/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov, Leonid Khramov
 */
import React, { Component } from "react"

import "./TopBar.css"

class TopBar extends Component {
    render() {
        return (
            <nav className="TopBar header">
                <div className="trace-container">
                    <div
                        className="button-block"
                        onClick={(e) => {
                            e.preventDefault()
                            if (this.props.openMenu) this.props.openMenu()
                        }}
                    >
                        {!this.props.hideMenu && (
                            <a href="#/">
                                <i className="trace-icon hamburger-white" />
                                {this.props.alert && (
                                    <div className="dot"></div>
                                )}
                            </a>
                        )}
                    </div>
                    <div className="logo-block">
                        <i className="trace-small-logo" />
                        <a href="#/">
                            <h2>Account</h2>
                        </a>
                    </div>
                </div>
            </nav>
        )
    }
}

export default TopBar
